import type { CarEventData, CarEventType } from './types.ts'

/** An event of `type` with none of its optional fields filled in. */
export function emptyEventData(type: CarEventType): CarEventData {
  switch (type) {
    case 'FUEL':
      return { type, fuelAmount: undefined, fuelStation: undefined, fuelTypeOverride: undefined }
    case 'REPAIR':
      return { type, repairShop: undefined, description: undefined, items: [], fulfilledScheduleIds: [] }
    case 'INSURANCE_PAYMENT':
      return { type, policyId: undefined, installmentNumber: undefined }
    case 'TAX':
      return {
        type,
        taxType: undefined,
        taxPeriod: undefined,
        authority: undefined,
        referenceNumber: undefined,
      }
    case 'INSPECTION':
      return { type, station: undefined, result: undefined, validUntil: undefined }
    case 'REGISTRATION':
      return { type, authority: undefined, expiryDate: undefined }
    case 'CAR_WASH':
      return { type, washType: undefined }
    case 'PARKING':
      return { type, location: undefined, durationMinutes: undefined }
    case 'FINE':
      return {
        type,
        fineType: undefined,
        status: undefined,
        authority: undefined,
        referenceNumber: undefined,
        dueDate: undefined,
      }
    case 'MILEAGE_LOG':
      return { type }
    case 'SELL':
      return { type, buyerNotes: undefined }
    case 'BUY':
      return { type, sellerNotes: undefined }
    case 'TIRE_CHANGE':
      return { type, axle: undefined, tireType: undefined, brand: undefined, shop: undefined }
  }
}
